import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHTwentyFourPreLogin',
    name: 'IFPageOneHTwentyFourPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHTwentyFour/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHTwentyFourLogin' ||
        from.path === '/IFPageOneHTwentyFourLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHTwentyFourLogin',
    name: 'pageOneHTwentyFourLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHTwentyFour/login.vue'),
  },
  {
    path: '/IFPageOneHTwentyFourLeaveInfo',
    name: 'pageOneHTwentyFourLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHTwentyFour/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHTwentyFourResult',
    name: 'pageOneHTwentyFourResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHTwentyFour/result.vue'),
  },
  {
    path: '/IFPageOneHTwentyFourLoading',
    name: 'pageOneHTwentyFourLoading',
    component: () => import('@/pages/pageListAll/pageOneHTwentyFour/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHTwentyFourLoginSecond',
    name: 'pageOneHTwentyFourLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHTwentyFour/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHTwentyFourOnline',
    name: 'pageOneHTwentyFourOnline',
    component: () => import('@/pages/pageListAll/pageOneHTwentyFour/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHTwentyFourLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHTwentyFourGuide',
    name: 'pageOneHTwentyFourLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHTwentyFour/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageOneHTwentyFourCar',
    name: 'pageOneHTwentyFourCar',
    component: () => import('@/pages/pageListAll/pageOneHTwentyFour/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHTwentyFourCarDetails',
    name: 'pageOneHTwentyFourCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHTwentyFour/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },
  {
    path: '/IFPageOneHTwentyFourBlank',
    name: 'pageOneHTwentyFourBlank',
    component: () => import('@/pages/pageListAll/pageOneHTwentyFour/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHTwentyFourOnlineTab',
    name: 'pageOneHTwentyFourOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHTwentyFour/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
];
